import React, { createContext, useContext } from "react";
import { useScanState as useScanStateImpl } from "./useScanState";

const ScanStateContext = createContext<ReturnType<typeof useScanStateImpl> | null>(null);

export const ScanStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const scanState = useScanStateImpl();
  return (
    <ScanStateContext.Provider value={scanState}>
      {children}
    </ScanStateContext.Provider>
  );
};

export function useScanState() {
  const ctx = useContext(ScanStateContext);
  if (!ctx) throw new Error("useScanState must be used within a ScanStateProvider");
  return ctx;
} 